import CrudRepository from './CrudRepository'
export default class ChangeServiceStatusRepository extends CrudRepository {
  constructor () {
    super('core/api/services/changeState')
  }
}
